import { createI18n } from 'vue-i18n'

import en from './locales/en'
import sl from './locales/sl'

export type AvailableLocales = 'sl' | 'en'

/** A guest who has not chosen gets Slovenian unless their browser asks for something else. */
const initial = localStorage.getItem('locale') || (navigator.language.toLowerCase().startsWith('sl') ? 'sl' : 'en')

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           initial,
    fallbackLocale:   'en',
    messages:         { sl, en },
    availableLocales: ['sl', 'en'],
})

export default i18n
